import * as i18next from 'i18next'
import 'lazysizes'
import { initialRootState } from './site/root/rootState'
import { rootWidget } from './site/root/rootWidget'
// STYLING IMPORTS
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Stateful } from 'widgets-for-react'
import './styling/custom-theme/stylesheets/spa.scss'

export const main = async () => {
  let headers = new Headers()
  headers.append('content-type', 'application/json')

  let res = await fetch(`/api/v1/sharepoint/translations.json`, {
    method: 'get',
    credentials: 'include',
    headers: headers,
  })
  let resources = await res.json()

  const language = window.location.pathname.substring(1, 3)

  await i18next.default.init({
    ns: ['error'],
    nsSeparator: ":",
    lng: language == 'nl' || language == 'en' ? language : 'nl',
    resources: resources,
  })

  // let state: RootState | undefined = undefined

  const rootElement = document.getElementById('root')
  if (rootElement != null) {
    const root = createRoot(rootElement)
    root.render(
      <Stateful
        iow={rootWidget}
        initialState={initialRootState()}
        onStateChange={() => {}}
        // onStateChange={(s) => {
        // state = s
        // const root = document.getElementById('root')
        // const ssrRoot = document.getElementById('rootSSR')
        // if (!window.hasSSR) {
        //   ssrRoot?.parentNode?.removeChild(ssrRoot)
        //   return
        // }
        // let releaseCounter = 10
        // let hasAsyncLoading = (e: any, parent: any) => {
        //   if (e == undefined) return false
        //   let entries = Object.entries(e)
        //   if ((e as any)['kind'] == 'fromPromise') return false
        //   for (let [key, value] of entries) {
        //     if (value == null || value == undefined) continue
        //     if (typeof value === 'function') continue
        //     if (value instanceof Date) continue
        //     if ((value as any)['type'] == 'async-widget') {
        //       if ((value as any)['kind'] == 'loading') {
        //         console.warn('found async loading', value, e, parent)
        //         return true
        //       }
        //     }
        //     if (typeof value === 'string' || value instanceof String) continue
        //     let hasValueAsyncLoading = hasAsyncLoading(value, e)
        //     if (hasValueAsyncLoading) return true
        //   }
        //   return false
        // }
        // let firstTime = true
        // console.log('root', root)
        // console.log('ssr root', ssrRoot)
        // let removeSSR = () => {
        //   setTimeout(
        //     () => {
        //       firstTime = false
        //       if (hasAsyncLoading(state, undefined) && releaseCounter > 0) {
        //         releaseCounter--
        //         console.log('found loading in state', state, releaseCounter)
        //         removeSSR()
        //         return
        //       }
        //       console.log('removing ssr', root, ssrRoot)
        //       console.log('removing ssr', root, ssrRoot)
        //       console.log('removing ssr', root, ssrRoot)
        //       console.log('removing ssr', root, ssrRoot)
        //       console.log('removing ssr', root, ssrRoot)
        //       console.log('removing ssr', root, ssrRoot)
        //       if (root) {
        //         root.style.display = ''
        //       }
        //       if (ssrRoot) {
        //         ssrRoot.style.display = 'none'
        //         setTimeout(() => ssrRoot.parentNode?.removeChild(ssrRoot), 100)
        //       }
        //     },
        //     firstTime ? 500 : 200
        //   )
        // }
        // removeSSR()
        // }}
      />
    )
  }
}

main()
